import { jsx as l, jsxs as t } from "react/jsx-runtime";
import "react";
var Z = (a) => /* @__PURE__ */ t("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...a,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#FCFCFC",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#A2001D",
      d: "m8.26 18.55-2.173-3.943 2.174-3.882 2.174 3.882L8.26 18.55Zm-4.347 0-2.174-3.943 2.174-3.882 2.174 3.882-2.174 3.944ZM8.26 29.275l-2.173-3.944L8.26 21.45l2.174 3.882-2.174 3.944Zm-4.347 0-2.174-3.944 2.174-3.882 2.174 3.882-2.174 3.944Zm6.522-25.393-.616-1.099a20.055 20.055 0 0 0-3.093 2.259L8.26 7.826l2.174-3.944ZM8.26 32.174l-1.55 2.77a20.055 20.055 0 0 0 3.09 2.262l.634-1.15-2.174-3.882Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#6DA544",
      d: "M12.174 25.217V38.41A19.934 19.934 0 0 0 20 40c8.6 0 15.93-5.428 18.756-13.044l-26.582-1.739Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#A2001D",
      d: "M38.756 26.956A19.958 19.958 0 0 0 40 20C40 8.954 31.046 0 20 0a19.94 19.94 0 0 0-7.826 1.59v25.367h26.582Z"
    })
  ]
});
export {
  Z as default
};
